import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {Pasta} from "../models/pasta";
import {ListaDocumento} from "../models/lista-documento";

@Injectable({
  providedIn: 'root'
})
export class DocumentoProcessoService{
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`DocumentoProcessoService`);
  }

  baseUrl = environment.apiUrl;

  adicionar(request: FormData): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/DocumentoProcesso`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionar')));
  }

  deletar(documento: number): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    // @ts-ignore
    return this.http
      .delete<BaseResponse<boolean>>(`${this.baseUrl}/DocumentoProcesso/${documento}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionar')));
  }

  buscarPorProcessoId(processo: number): Observable<BaseResponse<Pasta[]> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<ListaDocumento>>(`${this.baseUrl}/DocumentoProcesso/BuscarPorProcesso/${processo}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarPorProcessoId')));
  }

  downloadDocumento(id: number): Observable<BaseResponse<string> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<string>>(`${this.baseUrl}/DocumentoProcesso/Download/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('downloadDocumento')));
  }

  selecionarLista(): Observable<BaseResponse<ListaDocumento> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<ListaDocumento>>(`${this.baseUrl}/DocumentoProcesso`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarLista')))
  }

  listarPastasDocumento(): Observable<BaseResponse<Pasta[]> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<Pasta[]>>(`${this.baseUrl}/DocumentoProcesso/Pasta`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('listarPastasDocumento')))
  }

  novaPasta(request: { descricao: string, origemId: number }): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/DocumentoProcesso/NovaPasta`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('novaPasta')));
  }
}
